/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { AlertminerApiConfiguration as __Configuration } from '../alertminer-api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { ReportDiscrepancyModel } from '../models/report-discrepancy-model';
@Injectable({
  providedIn: 'root',
})
class DiscrepancyReportClientService extends __BaseService {
  static readonly ReportDiscrepancyPOSTPath = '/api/DiscrepancyReport/ReportDiscrepancy';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @param model undefined
   */
  ReportDiscrepancyPOSTResponse(model?: ReportDiscrepancyModel): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = model;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/DiscrepancyReport/ReportDiscrepancy`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * @param model undefined
   */
  ReportDiscrepancyPOST(model?: ReportDiscrepancyModel): __Observable<null> {
    return this.ReportDiscrepancyPOSTResponse(model).pipe(
      __map(_r => _r.body as null)
    );
  }
}

module DiscrepancyReportClientService {
}

export { DiscrepancyReportClientService }
